import { useEffect, useState } from 'react';
import { DesktopShell, MobileShell } from '@/components/dashboard/DashboardShell';
import { CampusMapContent } from '@/components/dashboard/CampusMapContent';

export default function CampusMap() {
  const [desktop, setDesktop] = useState(() => typeof window !== 'undefined' && window.matchMedia('(min-width: 1024px)').matches);
  useEffect(() => {
    const query = window.matchMedia('(min-width: 1024px)');
    const update = () => setDesktop(query.matches);
    update();
    query.addEventListener('change', update);
    return () => query.removeEventListener('change', update);
  }, []);
  // Keep one directory, one SVG, and one selection state mounted at every width.
  return <CampusMapContent Shell={desktop ? DesktopShell : MobileShell} />;
}
